import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { CollapsableSection } from './CollapsableSection';
export const AlertDeliveryOrder = ({ data }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useAlertUiTranslation();
    const escalationDelaySms = (_c = (_b = (_a = data.settings) === null || _a === void 0 ? void 0 : _a.escalationDelay) === null || _b === void 0 ? void 0 : _b.find((delay) => delay.channel === 'sms')) === null || _c === void 0 ? void 0 : _c.delay;
    const escalationDelayVoice = (_f = (_e = (_d = data.settings) === null || _d === void 0 ? void 0 : _d.escalationDelay) === null || _e === void 0 ? void 0 : _e.find((delay) => delay.channel === 'voice')) === null || _f === void 0 ? void 0 : _f.delay;
    return (React.createElement(CollapsableSection, { title: t('common.deliveryOrder'), header: React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
            React.createElement(Box, { sx: { flexGrow: 1 } }),
            data.deliveryMode && (React.createElement(Chip, { size: 'small', color: 'default', label: t(`enum.deliveryMode.${((_g = data.deliveryMode) !== null && _g !== void 0 ? _g : 'blast')}`) }))) },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                backgroundColor: themeColors.surface.secondary,
            } },
            data.deliveryMode === 'blast' && (React.createElement(Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: '50% 50%',
                    p: 2,
                    backgroundColor: themeColors.surface.tertiary,
                    borderRadius: 1,
                } },
                React.createElement(Typography, { variant: 'body2' }, t('common.blastDescription')))),
            escalationDelaySms != null && (React.createElement(Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: '50% 50%',
                    p: 2,
                    backgroundColor: themeColors.surface.tertiary,
                    borderRadius: 1,
                } },
                React.createElement(Typography, { variant: 'body2' }, t('common.escalationDelaySms')),
                React.createElement(Typography, { variant: 'subtitle2' }, t('common.countMinutes', { count: escalationDelaySms })))),
            escalationDelayVoice != null && (React.createElement(Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: '50% 50%',
                    p: 2,
                    backgroundColor: themeColors.surface.tertiary,
                    borderRadius: 1,
                } },
                React.createElement(Typography, { variant: 'body2' }, t('common.escalationDelayVoice')),
                React.createElement(Typography, { variant: 'subtitle2' }, t('common.countMinutes', { count: escalationDelayVoice })))))));
};
